<script lang="ts">
	import { format } from 'svelte-i18n';
	//Helpers
	import { validateIpAndPort } from '../../../helpers/validators';
	//Design system components
	import { Input, Button, Text, Alert, Loader, toast } from '@Shelly/shelly-design-system';
	//Components
	import DiscoveredDeviceInList from './DiscoveredDeviceInList.svelte';
	import { devices } from 'src/stores/lists/devices';
	import { get_local_shelly_info } from 'src/services/local_requests';
	import type { LocalRequest } from 'src/types/requests/local';

	export let inclusionData;

	let value = '';
	let error: string = '';
	let validDevice = false;
	let existingDevice = false;
	let disabled = false;
	let loading = false;

	const data = {
		id: '',
		gen: 0,
		type: '',
		ip: '',
	};

	const device = { id: '', category: '', channel: 0, gen: 0 };

	const handleResponse = (res: any) => {
		validDevice = true;
		data.id = res?.gen >= 2 ? res.mac : res?.longid == 1 ? res.mac : res.mac.substring(6, 12);

		data.gen = res?.gen >= 2 ? res?.gen : 1;
		data.type = typeof res.type !== 'undefined' ? res.type : res.model;
		data.ip = value;

		data.id = data.id.toLowerCase();
		existingDevice = typeof $devices[data.id] !== 'undefined';
		disabled = false;
		loading = false;
	};

	const handleCheck = async () => {
		if (inclusionData) inclusionData.selected = undefined;
		validDevice = false;
		loading = true;

		if (!validateIpAndPort(value)) {
			loading = false;
			error = $format('not_valid_ip_error_msg');
			return;
		} else {
			error = '';
		}

		disabled = true;

		const resGen1: LocalRequest = await get_local_shelly_info(device, value);
		if (resGen1.mac) {
			handleResponse(resGen1);
		} else if (!resGen1?.isok) {
			const resGen2: LocalRequest = await get_local_shelly_info({ ...device, gen: 2 }, value);
			if (resGen2.mac) {
				handleResponse(resGen2);
			} else if (!resGen2?.isok) {
				toast.open({
					type: 'danger',
					title: $format('not_shelly_desc'),
				});
				validDevice = false;
				existingDevice = false;
				disabled = false;
				loading = false;
			}
		}
	};
</script>

<Text class="mb-s">{$format('process_add_by_ip')}</Text>

<Input
	bind:value
	icon={'fas fa-microchip'}
	label={$format('placeholder_enter_ip')}
	id="add-device-ip-input"
	aria-labelledby="add-device-ip-input"
	class="mb-s"
	size="m"
	width="full"
	{disabled}
	{error}
	on:enter={handleCheck}
/>
<Button on:click={handleCheck} {disabled} class="mb-m" size="m" width="full"
	>{$format('button_check_device', { default: 'check device' })}</Button
>

{#if loading}
	<Loader size="m" class="d-flex justify-content-center mb-m" />
{:else if validDevice && !existingDevice}
	<!-- <DiscoveredDevice device={data} /> -->
	<DiscoveredDeviceInList device={data} bind:inclusionData />
{:else if existingDevice}
	<Alert
		type="info"
		message={$format('existingDevice', {
			default: 'The device is already owned by another user\/account.',
		})}
	/>
{/if}
